import {
  pgTable,
  uuid,
  text,
  timestamp,
  integer,
  index,
  uniqueIndex,
} from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// Timestamp helper
// ---------------------------------------------------------------------------

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// mcp_api_keys — Tenant-scoped API keys for MCP tool invocation
// ---------------------------------------------------------------------------

export const mcpApiKeys = pgTable(
  "mcp_api_keys",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    name: text("name").notNull(),
    keyPrefix: text("key_prefix").notNull(),
    /** hmac-sha256:<hex> for new keys; legacy sha256:<hex> rows may exist during rotation. Raw key is never stored. */
    keyHash: text("key_hash").notNull(),
    /** Domain scopes: ["crm", "email"] or ["*"] for all */
    scopedDomains: text("scoped_domains").array().default(["*"]).notNull(),
    /** Maximum AI risk classification this key can invoke */
    maxAiClassification: text("max_ai_classification")
      .default("limited")
      .notNull(),
    /** Calls per minute */
    rateLimit: integer("rate_limit").default(20).notNull(),
    lastUsedAt: timestamp("last_used_at", tz),
    revokedAt: timestamp("revoked_at", tz),
    createdAt: timestamp("created_at", tz).defaultNow().notNull(),
  },
  (table) => [
    index("idx_mcp_api_keys_tenant").on(table.tenantId),
    index("idx_mcp_api_keys_prefix").on(table.tenantId, table.keyPrefix),
    uniqueIndex("uq_mcp_api_keys_hash").on(table.keyHash),
  ],
);
